import React from "react";
import EditableTable from "./_EditableTable";

export default function OCM() {
  return (
    <>
      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500 section-eyebrow">Organizational Change &amp; Training</div>
        <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-zinc-900 mt-1">OCM &amp; Training</h2>
        <p className="text-sm text-zinc-500 mt-1 max-w-3xl">Stakeholder readiness · training curriculum · communications plan · post-go-live adoption metrics.</p>
      </div>

      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">Stakeholder readiness</div>
        <EditableTable
          sectionKey="ocm"
          listKey="readiness"
          testidPrefix="ocm-r"
          labelSingular="assessment"
          columns={[
            { key: "group", label: "Stakeholder group" },
            { key: "impact", label: "Impact", type: "select", options: ["Low", "Medium", "High"], width: "110px" },
            { key: "awareness", label: "Awareness %", type: "number", width: "120px" },
            { key: "readiness", label: "Readiness %", type: "number", width: "120px" },
            { key: "adoption", label: "Adoption %", type: "number", width: "120px" },
            { key: "owner", label: "Owner", width: "120px" },
          ]}
          emptyRow={() => ({ group: "", impact: "Medium", awareness: 0, readiness: 0, adoption: 0, owner: "" })}
        />
      </div>

      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">Training curriculum by role</div>
        <EditableTable
          sectionKey="ocm"
          listKey="training"
          testidPrefix="ocm-t"
          labelSingular="course"
          columns={[
            { key: "role", label: "Role", width: "160px" },
            { key: "course", label: "Course / module" },
            { key: "delivery", label: "Delivery", type: "select", options: ["ILT", "vILT", "eLearning", "Job aid", "Sandbox"], width: "110px" },
            { key: "hours", label: "Hours", type: "number", width: "90px" },
            { key: "audience", label: "Audience #", type: "number", width: "110px" },
            { key: "completion", label: "Completion %", type: "number", width: "130px" },
            { key: "status", label: "Status", type: "select", options: ["Backlog", "Content dev", "Ready", "Delivered"], width: "130px" },
          ]}
          emptyRow={() => ({ role: "", course: "", delivery: "eLearning", hours: 0, audience: 0, completion: 0, status: "Backlog" })}
        />
      </div>

      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">Communications plan</div>
        <EditableTable
          sectionKey="ocm"
          listKey="comms"
          testidPrefix="ocm-c"
          labelSingular="communication"
          columns={[
            { key: "date", label: "Date", type: "date", width: "140px" },
            { key: "channel", label: "Channel", type: "select", options: ["Email", "Town hall", "Newsletter", "Intranet", "Slack/Teams", "Video"], width: "130px" },
            { key: "audience", label: "Audience" },
            { key: "topic", label: "Topic / message" },
            { key: "owner", label: "Owner", width: "120px" },
            { key: "status", label: "Status", type: "select", options: ["Planned", "Drafted", "Approved", "Sent"], width: "110px" },
          ]}
          emptyRow={() => ({ date: "", channel: "Email", audience: "", topic: "", owner: "", status: "Planned" })}
        />
      </div>
    </>
  );
}
